<ng-template #passwordTooltip>
	<div class="password-tooltip">
		<div class="is-bold">{{ 'resetPassword.passwordRules' | translate: 'client' : userLanguage }}</div>
		<ul>
			<li>{{ 'resetPassword.passwordRule1' | translate: 'client' : userLanguage }}</li>
			<li>{{ 'resetPassword.passwordRule2' | translate: 'client' : userLanguage }}</li>
			<li>{{ 'resetPassword.passwordRule3' | translate: 'client' : userLanguage }}</li>
			<li>{{ 'resetPassword.passwordRule4' | translate: 'client' : userLanguage }}</li>
			<li>{{ 'resetPassword.passwordRule5' | translate: 'client' : userLanguage }}</li>
		</ul>
	</div>
</ng-template>

<div class="public-bg">
	<div class="public-content">
		<div class="public-app-logo">
			<img
				src="assets/images/logo.png"
				alt="App-Logo"
				class="is-logo-white" />
		</div>

		<div class="public-center-wrapper">
			<div class="public-wrapper">
				<h2 class="public-msg">
					{{ 'resetPassword.mainMessage' | translate: 'client' : userLanguage }}
				</h2>
				@if (!processCompleted) {
					<div class="public-wrapper-container">
						<div class="public-wrapper-content simple-card">
							<div class="public-wrapper-content-description">
								{{ 'resetPassword.subMessage' | translate: 'client' : userLanguage }}
							</div>
							<form
								#form="ngForm"
								name="formLogin"
								class="public-form"
								(submit)="resetPassword()">
								<eif-custom-input
									#password1Input
									[(ngModel)]="password1"
									[type]="'password'"
									[name]="'password1'"
									[label]="'resetPassword.enterPassword' | translate: 'client' : userLanguage"
									[autoFocus]="true"
									[autoComplete]="'new-password'"
									(valueChange)="onPassword1Change($event)"
									(validationChange)="onPassword1ValidationChange($event)"
									[required]="true"
									[icon]="'fa-solid fa-info-circle'"
									[tooltip]="passwordTooltip"
									[validationRules]="passwordValidationRules">
								</eif-custom-input>
								<eif-custom-input
									#password2Input
									[(ngModel)]="password2"
									[type]="'password'"
									[name]="'password2'"
									[label]="'resetPassword.reEnterPassword' | translate: 'client' : userLanguage"
									[autoComplete]="'new-password'"
									(valueChange)="onPassword2Change($event)"
									(validationChange)="onPassword2ValidationChange($event)"
									[required]="true">
								</eif-custom-input>
								<eif-custom-button
									[type]="'submit'"
									[text]="'login.submit'"
									[loading]="isSubmitting"
									[disabled]="isSubmitting"
									[fullWidth]="true"
									[class]="'mt-3'">
								</eif-custom-button>
							</form>
						</div>
						<div class="public-footer">
							<a
								class="public-footer-link is-hyperlink"
								href="mailto:{{ 'help.email.support.email' | translate }}">
								{{ 'help.email.support' | translate }}
							</a>
						</div>
					</div>
				} @else {
					<div class="public-wrapper-container">
						<div class="public-wrapper-content simple-card">
							<div class="public-wrapper-content-description">
								{{ 'resetPassword.completed' | translate: 'client' : userLanguage }}
							</div>
							<eif-custom-button
								[text]="'resetPassword.backToLogin'"
								[fullWidth]="true"
								(click)="navigateToLogin()"
								[class]="'mt-3'">
							</eif-custom-button>
						</div>
					</div>
				}
			</div>
		</div>
	</div>

	<eif-copyright></eif-copyright>
</div>
